import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import BookingFareForm from "apps/fares/BookingFare/BookingFareForm"
import { reverse } from "utils/urls"

export default function AirlineBookingFareUpdate(props) {
  const { t } = useTranslation()

  return (
    <BookingFareForm
      {...props}
      isUpdate
      detailEndpoint={`/fares/airline-fares/${props.match.params.id}/`}
      actionEndpoint={`/fares/airline-fares/${props.match.params.id}/`}
      errorUrl={reverse("airlineBookingFareList")}
      label={t("Edit airline booking fare")}
      successMessage={t("Airline Booking Fare was successfully saved.")}
      successUrl={reverse("airlineBookingFareList")}
    />
  )
}

AirlineBookingFareUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
